const ScopeActions = {
	API_GET_SCOPES_DATA: 'API_GET_SCOPES_DATA',
	API_GET_SCOPES_DATA_SUCCESS: 'API_GET_SCOPES_DATA_SUCCESS',
	API_POST_SCOPE_DATA: 'API_POST_SCOPE_DATA',
	API_POST_SCOPE_DATA_SUCCESS: 'API_POST_SCOPE_DATA_SUCCESS',
	API_PUT_SCOPE_DATA: 'API_PUT_SCOPE_DATA',
	API_PUT_SCOPE_DATA_SUCCESS: 'API_PUT_SCOPE_DATA_SUCCESS',
	API_GET_SCOPE_DATA: 'API_GET_SCOPE_DATA',
	API_GET_SCOPE_DATA_SUCCESS: 'API_GET_SCOPE_DATA_SUCCESS',
	API_DELETE_SCOPE_DATA: 'API_DELETE_SCOPE_DATA',
	API_CLEAR_SCOPE_DATA: 'API_CLEAR_SCOPE_DATA',
	API_GET_CLIENTS_LINK_TO_SCOPE: 'API_GET_CLIENTS_LINK_TO_SCOPE',
	API_GET_CLIENTS_LINK_TO_SCOPE_SUCCESS: 'API_GET_CLIENTS_LINK_TO_SCOPE_SUCCESS',
	API_CLEAR_CLIENTS_LINK_TO_SCOPE: 'API_CLEAR_CLIENTS_LINK_TO_SCOPE',
	API_PUT_CLIENTS_LINK_TO_SCOPE: 'API_PUT_CLIENTS_LINK_TO_SCOPE',
	API_PUT_CLIENTS_LINK_TO_SCOPE_SUCCESS: 'API_PUT_CLIENTS_LINK_TO_SCOPE_SUCCESS'
};
export default ScopeActions;
